import { styled } from '@automata/mui-theme';
import Table from '@mui/material/Table';

const PropertiesTableStyled = styled(Table)`
  height: 1px; // css hack to allow cell content to be 100% height
  padding: none;
  td,
  th {
    padding: ${({ theme }) => theme.spacing(1)}
      ${({ theme }) => theme.spacing(0.5)};
    &:first-of-type {
      padding-left: 0;
    }
    &:last-of-type {
      padding-right: 0;
    }
  }
`;

export default PropertiesTableStyled;
